import React, { forwardRef, useEffect, useState } from 'react'
import {
    MDBChipsInput,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    MDBInput,
    MDBSelect,
    MDBModalTitle,
    MDBModalHeader,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { addNewDirectory, getMisc } from '../../../apiclients/streamsapi_bridge';

const AADialByNameAdd = forwardRef((props, ref) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [aadirectoryTypes, setAADirectoryTypes] = useState({});


    const [centredModal, setCentredModal] = useState(false);
    const [directoryType, setDirectoryType] = useState(0);

    const toggleShow = () => setCentredModal(!centredModal);
    const { register, setValue, handleSubmit, formState, setError, focus, setFocus, watch } = useForm({
        defaultValues: {
            name: "",
            dir_type: 1
        }

    });

    const { isDirty, errors } = formState;

    useEffect(() => {
        async function getDirectoryTypes() {
            const response = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["directory_type"] }
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
            }
            const directoryType = tdata?.misc?.directoryType ?? {};
            setAADirectoryTypes(directoryType);
        }
        getDirectoryTypes();

    }, []);

    const onsubmit = async (data) => {
        let errorFlag = false;
        if (isDirty) {
            let updates = {};
            updates = {
                reqid: 147,
                siteid: JSON.parse(
                    sessionStorage.getItem("admin_session")
                ).siteid,

                name: data.name,
                dir_type: parseInt(data.dir_type),


            }
            // alert(JSON.stringify(updates));

            let saverep = await addNewDirectory(updates);
            console.log(saverep);
            let saverepeMsg = await saverep.json();
            console.log("response is :::::::::: " + JSON.stringify(saverepeMsg));
            // debugger;

            if (saverepeMsg.status == "success") {
                if (props.lunaUser) {
                    const newDir = {
                        id: saverepeMsg.directory_id,
                        name: data.name,
                        type: parseInt(data.dir_type),
                        is_presence_route: 0,
                        defaultval: 0,
                        flag: 0,
                    }
                    props.setnewDirectory(newDir);
                    props.setSuccessMessage(saverepeMsg.message);
                    props.onClose();

                } else {
                    localStorage.setItem("s_message", saverepeMsg.message);
                    props.onClose();
                    window.location.href = "/dialbydirectoriesLanding";
                }
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }
            }
        }
    }


    return (
        <>
            <form>


                <div>
                    <p>  {t("DirectoryName")}</p>

                    <div className="form width-100 ">
                        <input className="form-control mt-2" type="text" maxLength={50}
                            {...register("name", { required: "Name should not be empty" })}
                        />
                        {errors?.name && (
                            <p className="text-danger">{errors.name.message}</p>
                        )}
                    </div>
                    <p className="mt-3">  {t("DirectoryType")}</p>
                    <div className="phoneselect width-100">
                        <select className="form-control form-select selectname"
                            name="All Users"
                            // {...register("directory.create.dir_type")}
                            value={parseInt(watch("dir_type"))}
                            onChange={(e) => setValue("dir_type", parseInt(e.target.value), { shouldDirty: true })}
                        >
                            {aadirectoryTypes &&
                                Object.entries(aadirectoryTypes).map(([key, value]) => (
                                    <option value={parseInt(value)}>{key}</option>
                                ))}
                        </select>
                    </div>
                </div>
                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                        {t("add")}</button>
                </div>

            </form>

        </>
    )
});

export default AADialByNameAdd
